import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Pill } from "lucide-react";

export default function PepFloRedirect() {
  const navigate = useNavigate();
  const [count, setCount] = useState(3);

  useEffect(() => {
    const timer = setInterval(() => setCount(c => c - 1), 1000);
    const redirect = setTimeout(() => navigate("/"), 3000);
    return () => { clearInterval(timer); clearTimeout(redirect); };
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-white to-amber-50 flex items-center justify-center p-4" data-testid="pepflo-redirect-page">
      <div className="text-center">
        <div className="flex items-center gap-3 justify-center mb-6">
          <div className="w-14 h-14 rounded-full bg-amber-500 flex items-center justify-center">
            <Pill className="w-7 h-7 text-white" />
          </div>
          <div>
            <span className="font-bold text-3xl tracking-tight text-slate-900" style={{ fontFamily: "'Outfit', sans-serif" }}>
              Pep<span className="text-amber-500">Flo</span>
            </span>
            <p className="text-xs text-slate-500">Peptide Therapy Platform</p>
          </div>
        </div>
        <div className="bg-white rounded-2xl border border-purple-100 shadow-[0_8px_30px_rgb(0,0,0,0.04)] p-10 max-w-md">
          <h2 className="text-xl font-semibold text-slate-900 mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>
            PepFlo is now part of GLPFlo
          </h2>
          <p className="text-slate-600 mb-6">
            Our peptide therapy services are now available through GLPFlo, our comprehensive GLP-1 and peptide telehealth platform.
          </p>
          <p className="text-sm text-purple-600">Redirecting to GLPFlo in {count}...</p>
          <div className="mt-4">
            <button onClick={() => navigate("/")} className="text-sm text-slate-400 hover:text-purple-600 transition-colors">
              Go to GLPFlo now
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
